import React, { useEffect, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import { Dialog } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { FileDropZone } from '@components/custom'
import PropTypes from 'prop-types'
import './FileUploadDialog.scss'
import SearchPropertyList from '../SearchPropertyList/SearchPropertyList'
import ListInfo from '../ListInfo/ListInfo'
import { connect } from 'react-redux'
import Comps from '@engine/comps'
import CircularProgress from '@material-ui/core/CircularProgress'
import Property from '@engine/property'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'


export const FileUploadDialog = props => {
  const [isListInfoOpen, setIsListInfoOpen] = useState(false)
  const [isListSearched, setIsListSearched] = useState(false)

  useEffect(
    () => {
      if (props.listInfoLoading === 'Completed') {
        setIsListInfoOpen(true)
      }

      if (props.propertySearchListLookup?.length) {
        setIsListSearched(true)
      } else {
        setIsListSearched(false)
      }

      if (props.isPropertyDataReady) {
        resetListStateSlices()
      }
    },
    [
      props.listInfoLoading,
      props.propertySearchListLookup,
      props.isPropertyDataReady
    ]
  )

  const visibility = props.errorOnFileDrop.errorOnDrop ? 'show' : 'hide'
  const listItemClicked = listItem => {
    const { omniViewPropertyListId, polarisPropertySearchCriteriaId } = listItem
    const payload = {
      listDetails: { polarisPropertySearchCriteriaId, omniViewPropertyListId }
    }
    // get list Info API throguh redux-logic
    props.getListInfo(payload)
  }

  const resetListStateSlices = () => {
    props.resetSelectedListInfo()
    props.resetListSearchResults()
  }

  const confirmListHandler = listDetails => {
    props.createProjectFromList({
      projectType: listDetails.projectType,
      listName: listDetails.listName
    })
  }

  const listConfirmationCancelled = () => {
    setIsListInfoOpen(false)
    resetListStateSlices()
  }


  return <div className="file-upload-dialog">
      <Dialog open={props.open} aria-labelledby="discard-dialog-title">
        {isListInfoOpen ? <ListInfo listInfo={props.listInfo} confirmListHandler={confirmListHandler} listConfirmationCancelled={listConfirmationCancelled} close={props.close} /> : <Grid className="root" container direction="column" alignItems="center">
            <Grid item>
              <div className="area" data-testid="fileupload-dialog">
                <div data-testid="display-text">
                  <div className="heading-with-close">
                    <Typography align="center" variant="h1" gutterBottom>
                      Create New Project
                    </Typography>
                    <IconButton aria-label="close" className="dialogue-close" onClick={props.close}>
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <SearchPropertyList listItemClicked={listItemClicked} resetListSearchResults={props.resetListSearchResults} />
                </div>
                <FileDropZone onDropSuccess={props.onDropSuccess} errorOnFileDrop={props.errorOnFileDrop} isListSearched={isListSearched} />
                <div className={`error-message-box ${visibility}`}>
                  <span className="message" data-testid="error-message">
                    {props.errorOnFileDrop.errorMessage || 'Unknown error occurred'}
                  </span>
                </div>
                {props.listInfoLoading === 'InProgress' && <div className="list-details-loader">
                    <CircularProgress />
                  </div>}
              </div>
            </Grid>
          </Grid>}
      </Dialog>
    </div>
}

FileUploadDialog.propTypes = {
  dropRejectHandler: PropTypes.func,
  errorOnFileDrop: PropTypes.shape({
    errorOnDrop: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  close: PropTypes.func,
  open: PropTypes.bool,
  onDropSuccess: PropTypes.func,
  listInfo: PropTypes.object,
  getListInfo: PropTypes.func,
  listInfoLoading: PropTypes.string,
  isPropertyDataReady: PropTypes.bool,
  isSearchListLoading: PropTypes.bool,
  createProjectFromList: PropTypes.func,
  resetSelectedListInfo: PropTypes.func,
  propertySearchListLookup: PropTypes.array,
  resetListSearchResults: PropTypes.func
}

const mapStateToProps = state => ({
  listInfo: Comps.selectors.comps.listInfo(state),
  listInfoLoading: Comps.selectors.comps.listInfoLoading(state),
  isPropertyDataReady: Comps.selectors.comps.isPropertyDataReady(state),
  propertySearchListLookup: Property.selectors.property.propertySearchListLookup(
    state
  ),
  isSearchListLoading: Property.selectors.property.isSearchListLoading(
    state
  )
})

const mapDispatchToProps = {
  getListInfo: Comps.actions.getListInfo,
  createProjectFromList: Comps.actions.createProjectFromList,
  resetSelectedListInfo: Comps.actions.resetSelectedListInfo,
  resetListSearchResults: Property.actions.resetListSearchResults
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FileUploadDialog)
